import { render } from "./SubmitOrder.vue?vue&type=template&id=4de651fc"
import script from "./SubmitOrder.vue?vue&type=script&lang=js"
export * from "./SubmitOrder.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proj\\Apps\\takht-jamshid\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__